import createWithActionCreator from "./helpers/createWithActionCreator";

export const GET_BUCKETS_LIST_PENDING = "GET_BUCKETS_LIST_PENDING";
export const GET_BUCKETS_LIST_REJECTED = "GET_BUCKETS_LIST_REJECTED";
export const GET_BUCKETS_LIST_FULFILLED = "GET_BUCKETS_LIST_FULFILLED";

export const GET_BUCKET_FOLDERS_PENDING = "GET_BUCKET_FOLDERS_PENDING";
export const GET_BUCKET_FOLDERS_REJECTED = "GET_BUCKET_FOLDERS_REJECTED";
export const GET_BUCKET_FOLDERS_FULFILLED = "GET_BUCKET_FOLDERS_FULFILLED";

export const GET_DATE_FOLDER_CONTENTS_PENDING =
  "GET_DATE_FOLDER_CONTENTS_PENDING";
export const GET_DATE_FOLDER_CONTENTS_REJECTED =
  "GET_DATE_FOLDER_CONTENTS_REJECTED";
export const GET_DATE_FOLDER_CONTENTS_FULFILLED =
  "GET_DATE_FOLDER_CONTENTS_FULFILLED";

export const GET_PERFORMANCE_FOLDER_CONTENTS_PENDING =
  "GET_PERFORMANCE_FOLDER_CONTENTS_PENDING";
export const GET_PERFORMANCE_FOLDER_CONTENTS_REJECTED =
  "GET_PERFORMANCE_FOLDER_CONTENTS_REJECTED";
export const GET_PERFORMANCE_FOLDER_CONTENTS_FULFILLED =
  "GET_PERFORMANCE_FOLDER_CONTENTS_FULFILLED";

export const GET_RH20KMID_CONTENTS_PENDING = "GET_RH20KMID_CONTENTS_PENDING";
export const GET_RH20KMID_CONTENTS_REJECTED = "GET_RH20KMID_CONTENTS_REJECTED";
export const GET_RH20KMID_CONTENTS_FULFILLED =
  "GET_RH20KMID_CONTENTS_FULFILLED";

export const GET_DOWNLOAD_FILE_PENDING = "GET_DOWNLOAD_FILE_PENDING";
export const GET_DOWNLOAD_FILE_FULFILLED = "GET_DOWNLOAD_FILE_FULFILLED";
export const GET_DOWNLOAD_FILE_REJECTED = "GET_DOWNLOAD_FILE_REJECTED";

export const getBucketsListPending = params => {
  return {
    type: GET_BUCKETS_LIST_PENDING,
    payload: { params }
  };
};

export const getBucketsListRejected = error => ({
  type: GET_BUCKETS_LIST_REJECTED,
  payload: error
});

export const getBucketsListFulfilled = payload => {
  return {
    type: GET_BUCKETS_LIST_FULFILLED,
    payload
  };
};

export const getBucketFoldersPending = bucketName => ({
  type: GET_BUCKET_FOLDERS_PENDING,
  payload: { bucketName }
});

export const getBucketFoldersRejected = error => ({
  type: GET_BUCKET_FOLDERS_REJECTED,
  payload: error
});

export const getBucketFoldersFulfilled = payload => ({
  type: GET_BUCKET_FOLDERS_FULFILLED,
  payload
});

export const getDateFolderContentsPending = params => ({
  type: GET_DATE_FOLDER_CONTENTS_PENDING,
  payload: { params }
});

export const getDateFolderContentsRejected = error => ({
  type: GET_DATE_FOLDER_CONTENTS_REJECTED,
  payload: error
});

export const getDateFolderContentsFulfilled = payload => ({
  type: GET_DATE_FOLDER_CONTENTS_FULFILLED,
  payload
});

export const getPerformanceFolderContentsPending = params => ({
  type: GET_PERFORMANCE_FOLDER_CONTENTS_PENDING,
  payload: { params }
});

export const getPerformanceFolderContentsRejected = error => ({
  type: GET_PERFORMANCE_FOLDER_CONTENTS_REJECTED,
  payload: error
});

export const getPerformanceFolderContentsFulfilled = payload => ({
  type: GET_PERFORMANCE_FOLDER_CONTENTS_FULFILLED,
  payload
});

export const getRH20KMIDContentsPending = params => ({
  type: GET_RH20KMID_CONTENTS_PENDING,
  payload: { params }
});

export const getRH20KMIDContentsRejected = error => ({
  type: GET_RH20KMID_CONTENTS_REJECTED,
  payload: error
});

export const getRH20KMIDContentsFulfilled = payload => ({
  type: GET_RH20KMID_CONTENTS_FULFILLED,
  payload
});

export const getDownloadFilePending = path => ({
  type: GET_DOWNLOAD_FILE_PENDING,
  payload: { path }
});

export const getDownloadFileFulfilled = url => ({
  type: GET_DOWNLOAD_FILE_FULFILLED,
  payload: url
});

export const getDownloadFileRejected = error => ({
  type: GET_DOWNLOAD_FILE_REJECTED,
  payload: error
});

export const withGetBucketsList = createWithActionCreator(
  "getBucketsList",
  getBucketsListPending
);

export const withGetBucketFolders = createWithActionCreator(
  "getBucketFolders",
  getBucketFoldersPending
);

export const withGetDateFolderContents = createWithActionCreator(
  "getDateFolderContents",
  getDateFolderContentsPending
);

export const withGetPerformanceFolderContents = createWithActionCreator(
  "getPerformanceFolderContents",
  getPerformanceFolderContentsPending
);

export const withGetRH20KMIDContents = createWithActionCreator(
  "getRH20KMIDContents",
  getRH20KMIDContentsPending
);

export const withGetFileDownload = createWithActionCreator(
  "getDownlaodFile",
  getDownloadFilePending
);
